module.exports = __webpack_public_path__ + "img/sint-eustatius.adef4a1b.png";